import { faCheck, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, CircularProgress, TextField, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { fillZero } from "app/tools/common"
import React from "react"
import Countdown, { CountdownRendererFn } from "react-countdown"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { Popup } from "ui/components/Popup"
import { getUserInfo, logout, logoutAndRedirectToHomePage } from "user/tools/common"
import { reLogin } from "user/tools/relogin"

export interface ISessionWillExpirePopupProps {
  isOpened: boolean
}

// Warning : Don't use React.memo for this function else it will broke the <Countdown /> component
const CountdownRenderer: CountdownRendererFn = ({ minutes, seconds }) => (
  <Typography color="error" fontSize=".9rem">
    {fillZero(minutes)}:{fillZero(seconds)}
  </Typography>
)

const SessionWillExpirePopupFn = React.memo(({ isOpened }: ISessionWillExpirePopupProps) => {
  const [password, setPassword] = React.useState("")
  const [isLogin, setIsLogin] = React.useState(false)
  const [loginError, setLoginError] = React.useState("")
  if (!isOpened) {
    return null
  }
  const submit = () => {
    setIsLogin(true)
    setLoginError("")
    reLogin(password)
      .then(() => {
        setIsLogin(false)
        setPassword("")
      })
      .catch(errorKey => {
        setIsLogin(false)
        setPassword("")
        setLoginError(translate(errorKey))
      })
  }
  const canLogin = password.length > 1
  return (
    <Popup
      id="re-login-popup"
      title={translate("user.relogin.title")}
      onClose={() => {
        /* nothing to do */
      }}
      displayCloseButton={false}
      displayCloseIcon={false}>
      <FlexBox vertical gap sx={{ p: "1rem" }}>
        <Typography color="error">{translate("user.relogin.message")}</Typography>
        <FlexBox jc="space-evenly" fullWidth>
          <TextField
            id="relogin-password"
            value={password}
            type="password"
            label={translate("label.password")}
            onChange={event => {
              setPassword(event.target.value || "")
              if (loginError) {
                setLoginError("")
              }
            }}
            onKeyUp={event => {
              if (event && event.key === "Enter") {
                submit()
              }
            }}
            sx={{ minWidth: "14rem" }}
            size="small"
          />
          <Countdown
            date={getUserInfo().tokenExpirationDateTime}
            renderer={CountdownRenderer}
            onComplete={() => logout()}
          />
        </FlexBox>
        {loginError && (
          <Typography color="error" fontSize=".85rem">
            {loginError}
          </Typography>
        )}
        <FlexBox jc="end" fullWidth gap>
          <Button
            variant="outlined"
            startIcon={<FontAwesomeIcon icon={faTriangleExclamation} />}
            onClick={() => logoutAndRedirectToHomePage(true)}>
            {translate("logout.title")}
          </Button>
          <Button
            variant="contained"
            disabled={!canLogin}
            startIcon={
              isLogin ? (
                <CircularProgress sx={{ color: theme => theme.palette.primary.main, width: "1rem" }} size="20" />
              ) : (
                <FontAwesomeIcon icon={faCheck} />
              )
            }
            onClick={() => submit()}>
            {translate("button.continue")}
          </Button>
        </FlexBox>
      </FlexBox>
    </Popup>
  )
})

export const SessionWillExpirePopup = connect(
  (state: IRootState): ISessionWillExpirePopupProps => ({
    isOpened: state.user.isReLoginPopupOpened
  })
)(SessionWillExpirePopupFn)
